import { HighlightedBoxPageSection } from "../../models/page-builder/highlighted-box.model";

export const MOCK_PAGE_HIGHLIGHTED_BOX_SECTION: HighlightedBoxPageSection = {
  type: "highlighted-box",
  content: {
    header: {
      title: "Frequently asked questions",
      titleColor: "#000000",
      subtitle:
        "Everything you need to know about the product and billing.",
      subTitleColor: "#000000",
    },
    benefits: { items: [
      {
        text: "Does your employer sponsor online training? Consider requesting a one year or lifetime subscription as a training request (see FAQ below, multiple options available).",
        color: "#000000",
      },
      {
        text: "Free for teachers, discounts available for educational institutions, please email to activate your account.",
        color: "#000000",
      },
      {
        text: "font-family: Inter;\n" +
          "font-size: 13px;\n" +
          "font-weight: 400;\n" +
          "line-height: 16px;\n" +
          "text-align: left;\n",
        color: "#000000",
      },
        {
          text: "50% student discount available, simply email us to get your discount.",
          color: "#000000"
        }
    ]},
    images: {
      heroIcon: {
        type: "image",
        originalFileName: "b3d",
        uploadFileName: "3d",
        url: "https://lh3.googleusercontent.com/a/ACg8ocLgBQ3SNT3PPxMatA7RJwbxk8lQdwwoaQ-zIUzrWPHh=s96-c",
        imageSettings: {
          overlayWithBackground: true,
          opacity: 0.1,
          blending: "normal",
          blur: 2,
          grayScale: 10,
          contrast: 100,
        },
      },
      heroImage: {
        type: "image",
        originalFileName: "b3d",
        uploadFileName: "3d",
        url: "https://plus.unsplash.com/premium_photo-1676496046656-cdad44276497?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8aGlsbHNpZGV8ZW58MHx8MHx8fDA%3D",
        imageSettings: {
          overlayWithBackground: true,
          opacity: 0.1,
          blending: "normal",
          blur: 2,
          grayScale: 10,
          contrast: 100,
        },
      },
      listIcon: {
        enabled: true,
        svgName: "optionIcon-1",
        color: "red",
      },
    },
  },
  design: {
    layout: {
      blockStyle: "card",
      headingAlignment: "center",
      heroImageAlignment: "left",
      heroIconAlignment: "left",
    },
    appearance: {
      cardBackgroundColor: "white",
      backgroundColor: "white",
      backgroundImage: null/*{
        type: "image",
        originalFileName: "b3d",
        uploadFileName: "3d",
        url: "https://firebasestorage.googleapis.com/v0/b/chidume-local-dev.appspot.com/o/QqPcvz32KBXeg10On5kZNSwy0WD2%2FpageBuilder%2F1%2FVector.png?alt=media&token=4d2e4523-c709-4c00-9059-1ba1c8ca4314",
        imageSettings: {
          overlayWithBackground: true,
          opacity: 0.1,
          blending: "normal",
          blur: 2,
          grayScale: 10,
          contrast: 100,
        },
      }*/,
    },
  },
}
